import { axiosInstance, config } from "../axios";
import { URL_API_ACCESS } from "../urls";
import * as api from "./openapi";

export const apiAccess = {
  Common: new api.CommonApi(config, URL_API_ACCESS, axiosInstance),
  Roles: new api.RolesApi(config, URL_API_ACCESS, axiosInstance),
  Users: new api.UsersApi(config, URL_API_ACCESS, axiosInstance),
};
